export const ROUTINE_CHAT_PROMPT =
  'Suggest me routines which will help me save time and attention, and then help me create the ones I pick.';
